module.exports = {"140212100":"新荣镇","140212101":"古店镇","140212102":"花园屯镇","140212200":"破鲁堡乡","140212202":"郭家窑乡","140212206":"西村乡","140212209":"堡子湾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140212.json
// module id = 360
// module chunks = 0